export default __webpack_public_path__ + "static/1455-9fe7300598fb997ed8f3e0625ba2704f.gif";